import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
const SvgComponent = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1em"
        height="1em"
        fill="none"
        viewBox="0 0 20 20"
        ref={ref}
        {...props}
    >
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M3 4.7a.7.7 0 0 1 .7-.7h12.6a.7.7 0 1 1 0 1.4H3.7a.7.7 0 0 1-.7-.7Zm0 3.029a.7.7 0 0 1 .7-.7h12.6a.7.7 0 1 1 0 1.4H3.7a.7.7 0 0 1-.7-.7Zm0 3.028a.7.7 0 0 1 .7-.7h6.452a.7.7 0 1 1 0 1.4H3.7a.7.7 0 0 1-.7-.7Zm10.323 0a.7.7 0 0 1 .7-.7h.759c1.223 0 2.218.99 2.218 2.214a2.216 2.216 0 0 1-2.218 2.215H12.68l.32.318a.7.7 0 0 1-.99.992l-1.518-1.515a.7.7 0 0 1 0-.99l1.518-1.515a.7.7 0 0 1 .99.991l-.32.319h2.102a.816.816 0 0 0 .818-.815.816.816 0 0 0-.818-.814h-.76a.7.7 0 0 1-.7-.7ZM3 13.786a.7.7 0 0 1 .7-.7h4.554a.7.7 0 1 1 0 1.4H3.7a.7.7 0 0 1-.7-.7Z"
            clipRule="evenodd"
        />
    </svg>
);
const ForwardRef = forwardRef(SvgComponent);
export default ForwardRef;
